import React from "react";
import backgroundImage from "../../assets/images/Vector 17.svg";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  Percentage?: number;
  backgroundColor: string;
  color?: string;
  percentageColor?:string;
}

const StatusCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  color,
  Percentage,
  percentageColor,
  backgroundColor,
}) => {


  const ArrowIcon =  ArrowDropUpIcon;

  return (
    <div
      style={{
        backgroundColor: backgroundColor || "#f5f5f5",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        padding: "16px 20px",
        width: "100%",
        height: "100%",
        minHeight:"100px",
        border: "1px solid #D6E6FB",
        position: "relative",
        overflow: "hidden",
        color: color || "black",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* Background Image */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "130%",
          width: "70%",
          zIndex: 0,
        }}
      >
        <img
          src={backgroundImage}
          alt="background"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "8px",
        }}
      >
        {/* Title */}
        <p
          style={{
            fontSize: "15px",
            margin: 0,
            color: color || "black",
            fontWeight: 500,
          }}
        >
          {title}
        </p>

        {/* Percentage & Value */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {Percentage !== undefined && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: percentageColor, // translucent background
                borderRadius: "6px",
                padding: "2px 8px",
                fontSize: "12px",
                fontWeight: 500,
                color: "#ffffff",
              }}
            >
              <ArrowIcon sx={{ fontSize: 16, color:"#ffffff" }} />
              {Math.abs(Percentage)}%
            </div>
          )}

          <h2
            style={{
              fontSize: "22px",
              fontWeight: 600,
              margin: 0,
              color: color || "black",
            }}
          >
            {value}
          </h2>
        </div>

        {/* Subtitle */}
        {subtitle && (
          <p
            style={{
              fontSize: "12px",
              margin: 0,
              color: color || "black",
              textAlign:"right"
            
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default StatusCard;
